import { Box, Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { useEffect } from 'react';
import usePlanStore from '../../../../../../store/planStore';
import { Countries } from '../../../../../../shared/enums';
import Digital from './Digital/Digital';
import Offline from './Offline/Offline';
import OneReach from './OneReach/OneReach';
import CountryPlanSummary from './CountryPlanSummary/CountryPlanSummary';
import useTouchpoints from '../hooks/useTouchpoints';
import { Touchpoints } from '../../enums';
import prepareAvailableTouchpoints from '../utils/prepareAvailableTouchpoints';

function NestedCountryTabs() {
  const {
    selectedCountryISOCode,
    activeNestedTab,
    setActiveNestedTab,
    savedCountryForms,
    countryForms,
    selectedCountry,
    isLocked,
  } = usePlanStore();

  useEffect(() => {
    if (
      selectedCountryISOCode !== Countries.POLAND &&
      activeNestedTab === 'oneReach'
    ) {
      setActiveNestedTab('digital');
    }
  }, [activeNestedTab, selectedCountryISOCode]);

  const {
    data: availableTouchpoints,
    isFetching: isFetchingAvailableTouchpoints,
  } = useTouchpoints();

  const uniqueTouchpoints = prepareAvailableTouchpoints(availableTouchpoints);

  const lockedSx = {
    pointerEvents: isLocked ? 'none' : 'auto',
    opacity: isLocked ? 0.6 : 1,
  } as const;

  const oneReachLockedSx = {
    opacity: isLocked ? 0.6 : 1,
  } as const;

  return (
    <Box sx={{ backgroundColor: 'common.white', borderRadius: '5px' }}>
      <TabContext value={activeNestedTab}>
        <Tabs
          value={activeNestedTab}
          onChange={(e, val) => setActiveNestedTab(val)}
          sx={{ borderBottom: '1px solid', borderColor: 'gray.chrome' }}
        >
          <Tab label="Digital" value="digital" />
          <Tab
            label="Offline"
            value="offline"
            disabled={
              !countryForms[selectedCountry!]?.offline?.tv?.isAvailable &&
              !uniqueTouchpoints.includes(Touchpoints.ooh)
            }
          />
          <Tab
            label="One Reach"
            value="oneReach"
            disabled={
              selectedCountryISOCode !== Countries.POLAND ||
              (!savedCountryForms[selectedCountry!]?.calculatedBudget?.length &&
                !countryForms[selectedCountry!].offline?.tv?.offlineBudget)
            }
          />
          <Tab label="Country Summary" value="planSummary" />
        </Tabs>
        <TabPanel value="digital" sx={{ p: 0 }}>
          <Box sx={lockedSx}>
            <Digital
              availableTouchpoints={availableTouchpoints}
              isFetchingAvailableTouchpoints={isFetchingAvailableTouchpoints}
            />
          </Box>
        </TabPanel>
        <TabPanel value="offline" sx={{ p: 0 }}>
          <Box sx={lockedSx}>
            <Offline availableTouchpoints={availableTouchpoints} />
          </Box>
        </TabPanel>
        <TabPanel value="oneReach" sx={{ p: 0 }}>
          <Box sx={oneReachLockedSx}>
            <OneReach availableTouchpoints={availableTouchpoints} />
          </Box>
        </TabPanel>
        <TabPanel value="planSummary" sx={{ p: 0 }}>
          <Box sx={lockedSx}>
            <CountryPlanSummary />
          </Box>
        </TabPanel>
      </TabContext>
    </Box>
  );
}

export default NestedCountryTabs;
